// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file travel/v1/search.proto (package travel.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Agency } from "../../agency/v1/agency_pb";
import { file_agency_v1_agency } from "../../agency/v1/agency_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Place } from "../../place/v1/place_pb";
import { file_place_v1_place } from "../../place/v1/place_pb";
import type { Journey, Offer, Passenger, Transportation, UnnamedPassenger } from "./common_pb";
import { file_travel_v1_common } from "./common_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file travel/v1/search.proto.
 */
export const file_travel_v1_search: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agency_v1_agency, file_google_protobuf_struct, file_google_protobuf_timestamp, file_place_v1_place, file_travel_v1_common]);

/**
 * @generated from message travel.v1.OutwardRequest
 */
export type OutwardRequest = Message<"travel.v1.OutwardRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;

  /**
   * @generated from field: place.v1.Place origin = 2;
   */
  origin?: Place;

  /**
   * @generated from field: travel.v1.SearchDate outward_date = 3;
   */
  outwardDate?: SearchDate;

  /**
   * @generated from field: travel.v1.SearchDate inward_date = 4;
   */
  inwardDate?: SearchDate;

  /**
   * @generated from field: travel.v1.UnnamedPassenger main_passenger = 5;
   */
  mainPassenger?: UnnamedPassenger;

  /**
   * @generated from field: repeated travel.v1.Passenger additional_passengers = 6;
   */
  additionalPassengers: Passenger[];

  /**
   * @generated from field: repeated travel.v1.Transportation transportations = 7;
   */
  transportations: Transportation[];

  /**
   * @generated from field: bool bypass_overlapping = 8;
   */
  bypassOverlapping: boolean;

  /**
   * @generated from field: string travel_id = 9;
   */
  travelId: string;

  /**
   * @generated from field: travel.v1.SearchExtension extension = 10;
   */
  extension: SearchExtension;
};

/**
 * Describes the message travel.v1.OutwardRequest.
 * Use `create(OutwardRequestSchema)` to create a new message.
 */
export const OutwardRequestSchema: GenMessage<OutwardRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 0);

/**
 * @generated from message travel.v1.OutwardResponse
 */
export type OutwardResponse = Message<"travel.v1.OutwardResponse"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: repeated travel.v1.Solution solutions = 2;
   */
  solutions: Solution[];

  /**
   * @generated from field: repeated travel.v1.Passenger passengers = 3;
   */
  passengers: Passenger[];

  /**
   * @generated from field: repeated string warnings = 4;
   */
  warnings: string[];
};

/**
 * Describes the message travel.v1.OutwardResponse.
 * Use `create(OutwardResponseSchema)` to create a new message.
 */
export const OutwardResponseSchema: GenMessage<OutwardResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 1);

/**
 * @generated from message travel.v1.TravelOverlappingError
 */
export type TravelOverlappingError = Message<"travel.v1.TravelOverlappingError"> & {
  /**
   * @generated from field: agency.v1.Agency agency = 1;
   */
  agency?: Agency;
};

/**
 * Describes the message travel.v1.TravelOverlappingError.
 * Use `create(TravelOverlappingErrorSchema)` to create a new message.
 */
export const TravelOverlappingErrorSchema: GenMessage<TravelOverlappingError> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 2);

/**
 * @generated from message travel.v1.TravelSameMonthError
 */
export type TravelSameMonthError = Message<"travel.v1.TravelSameMonthError"> & {
  /**
   * @generated from field: agency.v1.Agency agency = 1;
   */
  agency?: Agency;
};

/**
 * Describes the message travel.v1.TravelSameMonthError.
 * Use `create(TravelSameMonthErrorSchema)` to create a new message.
 */
export const TravelSameMonthErrorSchema: GenMessage<TravelSameMonthError> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 3);

/**
 * @generated from message travel.v1.InwardRequest
 */
export type InwardRequest = Message<"travel.v1.InwardRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;

  /**
   * @generated from field: place.v1.Place destination = 2;
   */
  destination?: Place;

  /**
   * @generated from field: travel.v1.SearchDate inward_date = 3;
   */
  inwardDate?: SearchDate;

  /**
   * @generated from field: travel.v1.UnnamedPassenger main_passenger = 4;
   */
  mainPassenger?: UnnamedPassenger;

  /**
   * @generated from field: repeated travel.v1.Passenger additional_passengers = 5;
   */
  additionalPassengers: Passenger[];

  /**
   * @generated from field: string travel_id = 6;
   */
  travelId: string;

  /**
   * @generated from field: string outward_offer_id = 7;
   */
  outwardOfferId: string;

  /**
   * @generated from field: repeated travel.v1.Transportation transportations = 8;
   */
  transportations: Transportation[];

  /**
   * @generated from field: travel.v1.SearchExtension extension = 9;
   */
  extension: SearchExtension;
};

/**
 * Describes the message travel.v1.InwardRequest.
 * Use `create(InwardRequestSchema)` to create a new message.
 */
export const InwardRequestSchema: GenMessage<InwardRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 4);

/**
 * @generated from message travel.v1.InwardResponse
 */
export type InwardResponse = Message<"travel.v1.InwardResponse"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: repeated travel.v1.Solution solutions = 2;
   */
  solutions: Solution[];

  /**
   * @generated from field: repeated travel.v1.Passenger passengers = 3;
   */
  passengers: Passenger[];

  /**
   * @generated from field: repeated string warnings = 4;
   */
  warnings: string[];
};

/**
 * Describes the message travel.v1.InwardResponse.
 * Use `create(InwardResponseSchema)` to create a new message.
 */
export const InwardResponseSchema: GenMessage<InwardResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 5);

/**
 * @generated from message travel.v1.MoreRequest
 */
export type MoreRequest = Message<"travel.v1.MoreRequest"> & {
  /**
   * @generated from field: string dap_number = 1;
   */
  dapNumber: string;

  /**
   * @generated from field: string link = 2;
   */
  link: string;
};

/**
 * Describes the message travel.v1.MoreRequest.
 * Use `create(MoreRequestSchema)` to create a new message.
 */
export const MoreRequestSchema: GenMessage<MoreRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 6);

/**
 * @generated from message travel.v1.MoreResponse
 */
export type MoreResponse = Message<"travel.v1.MoreResponse"> & {
  /**
   * @generated from field: repeated travel.v1.Offer offers = 1;
   */
  offers: Offer[];
};

/**
 * Describes the message travel.v1.MoreResponse.
 * Use `create(MoreResponseSchema)` to create a new message.
 */
export const MoreResponseSchema: GenMessage<MoreResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 7);

/**
 * @generated from message travel.v1.Solution
 */
export type Solution = Message<"travel.v1.Solution"> & {
  /**
   * @generated from field: travel.v1.Journey journey = 1;
   */
  journey?: Journey;

  /**
   * @generated from field: repeated travel.v1.Offer offers = 2;
   */
  offers: Offer[];

  /**
   * @generated from field: optional string more = 3;
   */
  more?: string;
};

/**
 * Describes the message travel.v1.Solution.
 * Use `create(SolutionSchema)` to create a new message.
 */
export const SolutionSchema: GenMessage<Solution> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 8);

/**
 * @generated from message travel.v1.SearchDate
 */
export type SearchDate = Message<"travel.v1.SearchDate"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * @generated from field: travel.v1.DateType type = 2;
   */
  type: DateType;
};

/**
 * Describes the message travel.v1.SearchDate.
 * Use `create(SearchDateSchema)` to create a new message.
 */
export const SearchDateSchema: GenMessage<SearchDate> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 9);

/**
 * @generated from message travel.v1.PlacementChoiceRequest
 */
export type PlacementChoiceRequest = Message<"travel.v1.PlacementChoiceRequest"> & {
  /**
   * @generated from field: string travel_id = 1;
   */
  travelId: string;

  /**
   * @generated from field: string dap_number = 2;
   */
  dapNumber: string;

  /**
   * @generated from field: repeated string offer_ids = 3;
   */
  offerIds: string[];
};

/**
 * Describes the message travel.v1.PlacementChoiceRequest.
 * Use `create(PlacementChoiceRequestSchema)` to create a new message.
 */
export const PlacementChoiceRequestSchema: GenMessage<PlacementChoiceRequest> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 10);

/**
 * @generated from message travel.v1.PlacementChoiceResponse
 */
export type PlacementChoiceResponse = Message<"travel.v1.PlacementChoiceResponse"> & {
  /**
   * @generated from field: repeated travel.v1.SegmentPlacement placements = 1;
   */
  placements: SegmentPlacement[];
};

/**
 * Describes the message travel.v1.PlacementChoiceResponse.
 * Use `create(PlacementChoiceResponseSchema)` to create a new message.
 */
export const PlacementChoiceResponseSchema: GenMessage<PlacementChoiceResponse> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 11);

/**
 * @generated from message travel.v1.SegmentPlacement
 */
export type SegmentPlacement = Message<"travel.v1.SegmentPlacement"> & {
  /**
   * @generated from field: string segment_id = 1;
   */
  segmentId: string;

  /**
   * @generated from field: travel.v1.AvailablePlacementKind available_placement = 2;
   */
  availablePlacement?: AvailablePlacementKind;

  /**
   * @generated from field: repeated travel.v1.PlacementCapability placement_capabilities = 3;
   */
  placementCapabilities: PlacementCapability[];
};

/**
 * Describes the message travel.v1.SegmentPlacement.
 * Use `create(SegmentPlacementSchema)` to create a new message.
 */
export const SegmentPlacementSchema: GenMessage<SegmentPlacement> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 12);

/**
 * @generated from message travel.v1.PlacementCapability
 */
export type PlacementCapability = Message<"travel.v1.PlacementCapability"> & {
  /**
   * @generated from field: travel.v1.PlacementKind kind = 1;
   */
  kind: PlacementKind;

  /**
   * @generated from oneof travel.v1.PlacementCapability.capability
   */
  capability: {
    /**
     * @generated from field: google.protobuf.Struct seat_map = 2;
     */
    value: JsonObject;
    case: "seatMap";
  } | {
    /**
     * @generated from field: travel.v1.PlacementPreference preference = 3;
     */
    value: PlacementPreference;
    case: "preference";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message travel.v1.PlacementCapability.
 * Use `create(PlacementCapabilitySchema)` to create a new message.
 */
export const PlacementCapabilitySchema: GenMessage<PlacementCapability> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 13);

/**
 * @generated from message travel.v1.AvailablePlacementKind
 */
export type AvailablePlacementKind = Message<"travel.v1.AvailablePlacementKind"> & {
  /**
   * @generated from field: bool close_to = 1;
   */
  closeTo: boolean;

  /**
   * @generated from field: bool seat_map = 2;
   */
  seatMap: boolean;

  /**
   * @generated from field: bool placement_preferences = 3;
   */
  placementPreferences: boolean;
};

/**
 * Describes the message travel.v1.AvailablePlacementKind.
 * Use `create(AvailablePlacementKindSchema)` to create a new message.
 */
export const AvailablePlacementKindSchema: GenMessage<AvailablePlacementKind> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 14);

/**
 * @generated from message travel.v1.PlacementPreference
 */
export type PlacementPreference = Message<"travel.v1.PlacementPreference"> & {
  /**
   * @generated from field: travel.v1.PlacementPreferenceType type = 1;
   */
  type: PlacementPreferenceType;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: repeated travel.v1.PlacementOptions options = 3;
   */
  options: PlacementOptions[];
};

/**
 * Describes the message travel.v1.PlacementPreference.
 * Use `create(PlacementPreferenceSchema)` to create a new message.
 */
export const PlacementPreferenceSchema: GenMessage<PlacementPreference> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 15);

/**
 * @generated from message travel.v1.PlacementOptions
 */
export type PlacementOptions = Message<"travel.v1.PlacementOptions"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message travel.v1.PlacementOptions.
 * Use `create(PlacementOptionsSchema)` to create a new message.
 */
export const PlacementOptionsSchema: GenMessage<PlacementOptions> = /*@__PURE__*/
  messageDesc(file_travel_v1_search, 16);

/**
 * @generated from enum travel.v1.DateType
 */
export enum DateType {
  /**
   * @generated from enum value: DATE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATE_TYPE_DEPARTURE = 1;
   */
  DEPARTURE = 1,

  /**
   * @generated from enum value: DATE_TYPE_ARRIVAL = 2;
   */
  ARRIVAL = 2,
}

/**
 * Describes the enum travel.v1.DateType.
 */
export const DateTypeSchema: GenEnum<DateType> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 0);

/**
 * @generated from enum travel.v1.SearchExtension
 */
export enum SearchExtension {
  /**
   * @generated from enum value: SEARCH_EXTENSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEARCH_EXTENSION_NEXT = 1;
   */
  NEXT = 1,

  /**
   * @generated from enum value: SEARCH_EXTENSION_PREVIOUS = 2;
   */
  PREVIOUS = 2,
}

/**
 * Describes the enum travel.v1.SearchExtension.
 */
export const SearchExtensionSchema: GenEnum<SearchExtension> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 1);

/**
 * @generated from enum travel.v1.PlacementKind
 */
export enum PlacementKind {
  /**
   * @generated from enum value: PLACEMENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACEMENT_KIND_CLOSE_TO = 1;
   */
  CLOSE_TO = 1,

  /**
   * @generated from enum value: PLACEMENT_KIND_SEAT_MAP = 2;
   */
  SEAT_MAP = 2,

  /**
   * @generated from enum value: PLACEMENT_KIND_PREFERENCES = 3;
   */
  PREFERENCES = 3,
}

/**
 * Describes the enum travel.v1.PlacementKind.
 */
export const PlacementKindSchema: GenEnum<PlacementKind> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 2);

/**
 * @generated from enum travel.v1.PlacementPreferenceType
 */
export enum PlacementPreferenceType {
  /**
   * @generated from enum value: PLACEMENT_PREFERENCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACEMENT_PREFERENCE_TYPE_SEAT_POSITION = 1;
   */
  SEAT_POSITION = 1,

  /**
   * @generated from enum value: PLACEMENT_PREFERENCE_TYPE_SPACE_TYPE = 2;
   */
  SPACE_TYPE = 2,

  /**
   * @generated from enum value: PLACEMENT_PREFERENCE_TYPE_SEAT_DECK = 3;
   */
  SEAT_DECK = 3,
}

/**
 * Describes the enum travel.v1.PlacementPreferenceType.
 */
export const PlacementPreferenceTypeSchema: GenEnum<PlacementPreferenceType> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 3);

/**
 * @generated from enum travel.v1.PlacementSeatPosition
 */
export enum PlacementSeatPosition {
  /**
   * @generated from enum value: PLACEMENT_SEAT_POSITION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACEMENT_SEAT_POSITION_WINDOW = 1;
   */
  WINDOW = 1,

  /**
   * @generated from enum value: PLACEMENT_SEAT_POSITION_CORRIDOR = 2;
   */
  CORRIDOR = 2,

  /**
   * @generated from enum value: PLACEMENT_SEAT_POSITION_NO_PREFERENCE = 3;
   */
  NO_PREFERENCE = 3,
}

/**
 * Describes the enum travel.v1.PlacementSeatPosition.
 */
export const PlacementSeatPositionSchema: GenEnum<PlacementSeatPosition> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 4);

/**
 * @generated from enum travel.v1.PlacementSpaceType
 */
export enum PlacementSpaceType {
  /**
   * @generated from enum value: PLACEMENT_SPACE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACEMENT_SPACE_TYPE_SQUARE = 1;
   */
  SQUARE = 1,

  /**
   * @generated from enum value: PLACEMENT_SPACE_TYPE_DUO = 2;
   */
  DUO = 2,

  /**
   * @generated from enum value: PLACEMENT_SPACE_TYPE_NO_PREFERENCE = 3;
   */
  NO_PREFERENCE = 3,
}

/**
 * Describes the enum travel.v1.PlacementSpaceType.
 */
export const PlacementSpaceTypeSchema: GenEnum<PlacementSpaceType> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 5);

/**
 * @generated from enum travel.v1.PlacementSeatDeck
 */
export enum PlacementSeatDeck {
  /**
   * @generated from enum value: PLACEMENT_SEAT_DECK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLACEMENT_SEAT_DECK_HIGH = 1;
   */
  HIGH = 1,

  /**
   * @generated from enum value: PLACEMENT_SEAT_DECK_LOW = 2;
   */
  LOW = 2,

  /**
   * @generated from enum value: PLACEMENT_SEAT_DECK_NO_PREFERENCE = 3;
   */
  NO_PREFERENCE = 3,
}

/**
 * Describes the enum travel.v1.PlacementSeatDeck.
 */
export const PlacementSeatDeckSchema: GenEnum<PlacementSeatDeck> = /*@__PURE__*/
  enumDesc(file_travel_v1_search, 6);

/**
 * @generated from service travel.v1.SearchService
 */
export const SearchService: GenService<{
  /**
   * @generated from rpc travel.v1.SearchService.Outward
   */
  outward: {
    methodKind: "unary";
    input: typeof OutwardRequestSchema;
    output: typeof OutwardResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.SearchService.Inward
   */
  inward: {
    methodKind: "unary";
    input: typeof InwardRequestSchema;
    output: typeof InwardResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.SearchService.More
   */
  more: {
    methodKind: "unary";
    input: typeof MoreRequestSchema;
    output: typeof MoreResponseSchema;
  },
  /**
   * @generated from rpc travel.v1.SearchService.PlacementChoice
   */
  placementChoice: {
    methodKind: "unary";
    input: typeof PlacementChoiceRequestSchema;
    output: typeof PlacementChoiceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travel_v1_search, 0);

